import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { KeeniconComponent } from '../../partials';
import {
  HeaderTableColumnInterface,
  SortChangedInterface,
  SortOrder,
  TranslocoFunction,
} from '../../types';

@Component({
  selector: 'ui-sortable-header',
  imports: [NgClass, NgStyle, KeeniconComponent],
  templateUrl: './sortable-header.component.html',
  styleUrl: './sortable-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortableHeaderComponent {
  column = input.required<HeaderTableColumnInterface>();
  sortField = model.required<string | null>();
  last = input<boolean>(false);
  sortOrder = model<SortOrder | null>('ASC');
  t = input.required<TranslocoFunction>();
  sortChanged = output<SortChangedInterface>();

  onSortChanged() {
    const newOrder: SortOrder | null = this.toggleOrder();
    this.sortField.set(newOrder ? this.column().field : null);
    this.sortOrder.set(newOrder);
    this.sortChanged.emit({
      sortField: this.sortField(),
      sortOrder: newOrder,
    });
  }

  private toggleOrder(): SortOrder | null {
    if (this.sortField() === this.column().field) {
      switch (this.sortOrder()) {
        case 'ASC':
          return 'DESC';
        case 'DESC':
          return null;
        default:
          return 'ASC';
      }
    } else {
      return 'ASC';
    }
  }
}
